/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import RenderModel from "App/model";
import RenderNode from "App/render/webgl/nodes/render_node";
import WebGLRenderGraph from "App/render/webgl/render_graph";
import RenderObject from "App/geometry/objects/object";
import Factory from "App/render/webgl/nodes/factory";
import Pass from "App/render/webgl/passes/pass";
import {TransformNodeTypeName} from "App/render/webgl/nodes/type_names";
import IScene from "js_interface/src/scene_interface";
import WebGLContext from "App/web_gl_context";

export default
class TransformNode extends RenderNode {

    public static TypeName: string = TransformNodeTypeName;

    private model: RenderModel;

    constructor(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aParentNode: RenderNode, aShape: RenderObject) {
        super(aSceneAPI, aRenderGraph, aParentNode, aShape);

        this._typeName = TransformNode.TypeName;

        this.model = aShape.getModel();
    }

    public static create(aSceneAPI: IScene, aRenderGraph: WebGLRenderGraph, aParentNode: RenderNode, aShape: RenderObject) {
        return new TransformNode(aSceneAPI, aRenderGraph, aParentNode, aShape);
    }

    public release() {
        super.release();
    }

    public compareProperties(aShape: RenderObject): boolean {
        return aShape.getModel() === this.model;
    }

    public render(aRenderPass: Pass) {

        let gl = (this._context as WebGLContext).getWebGLRenderingContext();
        let activeShader: any  = aRenderPass.getActiveShaderRenderable();

        // set model transformation uniform
        gl.uniformMatrix4fv(activeShader.uniformLocations.u_model_transformation, false, this.model.getSceneAPIModel().getModelTransformationRef());

        return super.render(aRenderPass);
    }
}

Factory.register(TransformNode);
